<script setup>
import VacanciesFilter from "./VacanciesFilter.vue";
import { useVacancies } from "@/stores/vacancies";
import TheLoader from "@/components/TheLoader.vue";
import { ref } from "vue";

const store = useVacancies();
const filters = ref();

function apply(key) {
  return function (value) {
    store.applyFilter(key, value);
  };
}

function handleReset() {
  for (const filter of filters.value) {
    if (filter.type === "radio" || filter.type === "checkbox") {
      filter.reset();
    }
  }
  store.resetFilters();
}
</script>

<template>
  <p :class="$style.loading" v-if="store.loadingFilters">
    <span :class="$style.loader"><TheLoader /></span>
    Загружаем фильтры...
  </p>
  <template v-else>
    <form @submit.prevent>
      <VacanciesFilter
        ref="filters"
        v-for="filter of store.filters"
        :key="filter.key"
        :name="filter.key"
        v-bind="filter"
        :open="filter.defaultOpen"
        @change="(value) => store.applyFilter(filter.key, value)"
      />
      <input
        :class="$style.reset"
        :disabled="store.disabledReset"
        @click="handleReset"
        type="reset"
        value="Сбросить фильтр"
      />
    </form>
  </template>
</template>

<style module>
.loading {
  padding: 40px 0;
}

.loader {
  display: inline-block;
  color: #ed1651;
  margin-right: 1em;
}

.reset {
  display: inline-block;
  width: 100%;
  margin-top: 10px;
  padding: 13px 26px;
  border: none;
  border-radius: 5px;
  background-color: #eeeeee;
  font-size: 16px;
  font-weight: 600;
  color: #383131;
  cursor: pointer;
  transition-property: opacity, background-color;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.reset:hover {
  background-color: #dedede;
}

.reset:disabled {
  opacity: 0.6;
  cursor: default;
}

.reset:disabled:hover {
  background-color: #eeeeee;
}
</style>
